module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./components/artists/cards/artist-cards.template.html
// module id = ./components/artists/cards/artist-cards.template.html
// module chunks = 0